import React from 'react'
import Button from 'tfs.button'

import getLabels from '../../utils/getLabels'

export default ({ onSubmit, isFetching, fields, classes }) => (
  <form onSubmit={onSubmit} className={classes.form}>
    {fields.map(({ component, name, ...rest }) =>
      React.createElement(component, { key: name, name: name, ...rest })
    )}

    <Button
      name="search"
      icon="search"
      isDisabled={isFetching}
      data-element="search"
      type="submit"
    >
      {getLabels('search')}
    </Button>
  </form>
)
